export const loadTranslations = async (locale) => {
    const messages = await import(`../assets/locale/messages_${locale}.json`);
    return messages.default;
};
export const loadTPATranslations = async (locale) => {
    const messages = await import(`../assets/locale/messages-tpa_${locale}.json`);
    return messages.default;
};
export const loadLocaleDataset = async (locale) => {
    const messages = await import(`@wix/locale-dataset-data/resources/translations/messages_${locale}.json`);
    return messages.default;
};
//# sourceMappingURL=load-translations.js.map